export default __webpack_public_path__ + "static/mobiles-5b8f0bba5d2a08997b378e155e31b9ff.png";